import { useQuery } from "@apollo/client";
import { AppContext } from "App";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import { useModals } from "ModalProvider";
import { useContext, useState } from "react";
import { IoMdCheckmark, IoMdClose } from "react-icons/io";
import { USER_EDITOR } from "utils/permissions";
import { searchByProp } from "utils/search";
import { FETCH_ALL_USRS } from "../graphql";
import UserForm from "./UserForm";

function Accounts() {
  const { hasPermission } = useContext(AppContext);
  if (!hasPermission(USER_EDITOR)) {
    return (
      <div className="flex flex-1 items-center justify-center font-bold text-2xl h-screen text-gray-600">
        Not Allowed.
      </div>
    );
  }

  const [searchText, setSearchText] = useState("");
  const { loading, error, data } = useQuery(FETCH_ALL_USRS);
  const modal = useModals();

  function showForm(user) {
    modal.present({
      title: user ? "Edit Account" : "Create Account",
      center: true,
      children: <UserForm initialUser={user} onClose={modal.hide} />,
    });
  }

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <Page
      title="Accounts"
      rightButtons={<Button onClick={() => showForm()}>+ New Account</Button>}
    >
      <div className="flex-1 flex flex-col overflow-auto">
        <div className="p-4 lg:p-6">
          <SearchBar
            className="p-2 w-full"
            placeholder="Search customer by name or email"
            autoFocus
            type="text"
            value={searchText}
            onChange={(text) => setSearchText(text)}
          />
        </div>
        <div className="flex-1 card p-0 overflow-auto m-4 mt-0 lg:m-6 lg:mt-0">
          <table className="bg-white dark:bg-gray-800">
            <thead className="sticky lg:top-0">
              <tr className="bg-gray-200 dark:bg-gray-700">
                <th className="text-grey-darker text-left px-4 lg:px-6 py-4">
                  User
                </th>
                <th className="text-grey-darker w-12 px-4 lg:px-6 py-4">
                  Active
                </th>
              </tr>
            </thead>
            <tbody>
              {data.allUsers
                .filter((user) =>
                  searchByProp(
                    user,
                    ["email", "firstName", "lastName"],
                    searchText,
                  ),
                )
                .map((user) => (
                  <tr key={user.id}>
                    <td className="py-2 lg:py-3 px-4 lg:px-6 border-b border-gray-100 dark:border-gray-700">
                      <Button onClick={() => showForm(user)}>
                        {user.email}
                      </Button>
                    </td>
                    <td className="py-2 lg:py-3 px-4 lg:px-6 border-b border-gray-100 dark:border-gray-700">
                      <div className="flex justify-center">
                        <div
                          className={`w-4 ${user.isActive ? "text-green-500" : "text-red-500"}`}
                        >
                          {user.isActive ? <IoMdCheckmark /> : <IoMdClose />}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </Page>
  );
}

export default Accounts;
